import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import firebase from 'firebase';
import VueI18n from 'vue-i18n';
import { getUserLocale } from 'get-user-locale';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBuQTDa8qcMkMFz7Uno7zqRHeHjMhU2gUI",
  authDomain: "greenplay-online.firebaseapp.com",
  projectId: "greenplay-online",
  storageBucket: "greenplay-online.appspot.com",
  messagingSenderId: "730364230659",
  appId: "1:730364230659:web:db5cc0a8d57fcf5f142236",
  measurementId: "G-JEY1GJ2WEP"
};
var app = firebase.initializeApp(firebaseConfig);
const analytics = firebase.analytics();
Vue.config.productionTip = false
Vue.use(VueI18n)

const messages = {
  kr: {
    message: {
      btnGameStart: '게임시작',
      cutsceneTitle1: '병들어 가는 지구를 위해',
      cutsceneTitle2: '난 무엇을 할 수 있을까?',
      cutsceneTitle3: '난,',
      cutsceneTitle4: '오늘부터',
      cutsceneTitle5: '방구를',
      cutsceneTitle6: '참기로 했다.',

      cutsceneTitle1o: '평생 지구를 위해',
      cutsceneTitle2o: '방구를 참아왔다.',
      cutsceneTitle3o: '이젠...',
      cutsceneTitle4o: '',
      cutsceneTitle5o: '난,',
      cutsceneTitle6o: '바다에서',
      cutsceneTitle7o: '페트병을',
      cutsceneTitle8o: '줍기로 했다.',

      btnSignStart: '서명하고 게임 시작',
      warnName: '이름을 입력해 주세요!',
      btnGameStart2: '게임 플레이',
      btnGameRank: '순위표 보기',
      rank1: '1위',
      rank2: '2위',
      rank3: '3위',
      rankTotal: '우리가 함께 모은 메탄 가스 총량은?',
      rankCount: '방구를 참아라에 참여한 사람 수?',
      btnClose: '닫기',
      warnRotation: '세로모드로 플레이 해 주세요!',
      infoTouch: '손가락 세 개를 터치해서 시작합니다!',
      warnMobile: '모바일에서 플레이 해 주세요!',
      gameEndTitle: '방구 참기 실패',
      gameEndDesc1: '하지만,',
      gameEndDesc2: '당신의 방구는 영원히 기록될거에요',
      gameEndTitleO: '페트병 수거 실패',
      gameEndDesc1O: '당신의 시도는 또 실패할 것이다.',
      btnSave: '사진저장',
      btnReplay: '다시 플레이',
      me: '나',
      player: '명',
      placeholder: '이름',
      info1: '세 손가락을 올리면 게임을 시작합니다.',
      info2: '부딪혀서 죽었습니다.',
      info3: '손가락을 떼서 죽었습니다.',
      info4: '얼굴을 바꿨습니다.',
      info5: 'cc 부스터가 작동됩니다.',
      info6: '무적이 되었습니다.',
      warn: '세로 모드로 플레이하세요',
      btnShare: '공유하기',
      infoSave:'이미지를 길게 탭하면 저장할 수 있어요',
      btnLoading:'처리중...',
      bubble: [
        "어른은 보통 하루에 합계 0.5 ~ 1.5리터의 방구를 뀐다.",
        "방구는 음식물과 함께 입을 통해 들어간 공기가 장내용물의 발효에 의해 생겨난 가스와 혼합된 것이다.",
        "방귀의 양은 입을 통해 위로 들어간 공기의 양에 의해 좌우된다.",
        "음식을 빨리 먹는 사람은 입을 통해 위에 들어가는 공기의 양이 많아 지기 쉬우므로 방귀의 양도 많은 경향이 있다.",
        "식후 바로 잠을 자면 방귀가 많아질 가능성이 높다.",
        "방귀에서 역한 냄새가 나는 주요 원인은 방귀의 성분 중 '황화수소'에 있다.",
        "황화수소의 원료는 황을 포함한 아미노산인데, 모든 음식에는 황을 포함한 아미노산이 함유되어 있다.",
        "어쨌든 방귀를 방출할 때 나는 소리는 주로 항문괄약근의 진동 때문이다.",
        "방귀를 참게되면 장내 질소가스가 쌓여 대장이 부풀어 오른다.",
        "장내발효에 의한 가스는 주로 탄수화물의 이상발효로 증량되어 큰 소리를 동반하는 방귀의 원인이 된다.",
        "방구는 질소 77.5% 수소 0.25% 이산화탄소 0.63% 산소 20.55% 메테인 0.55% 황화수소 0.21% 인돌 0.14% 스카톨 0.07%, 박테리아로 구성되어있다.",
        "방귀는 정상적인 창자(장) 활동의 중요한 신호이다.",
        "동일하지만 항문으로 배출하면 방귀, 입으로 배출하면 트림이 된다.",
        "영화 감독 알렉스 라미레즈 말리스는 자신과 친구들의 1년치 방귀 소리를 NFT로 경매에 내놨다.	",
        "일반적으로 사람은 하루에 10-15번의 방구를 뀐다.",
        "방귀의 25%는 삼켰던 공기가 몸을 통과해 밖으로 나오는 것이다",
        "방귀의 75%는 다양한 소화과정을 통해 만들어 진다.",
        "소화과정을 통해 만들어지는 방귀는 주로 장내 세균이 식이섬유를 분해한 결과이다.",
        "방귀를 만드는 재료는 복합 탄수화물, 특히 올리고당(3-15개의 당 분자로 이루어진 탄수화물)이다.",
        "방귀를 만드는 올리고당은 콩, 뿌리식물, 양파, 양배추, 콜리플라워, 과일, 유제품에서 발견된다.",
        "보통 방귀의 99%이상은 전혀 냄새가 없는 물질로 이루어져 있다.",
        "방귀의 냄새는 방귀 중 1%에 극미량의 황화수소 및 기타 혼합물이 만들어 낸 결과이다.",
        "가스를 만들어내는 세균은 대부분이 대장(큰창자)에 살고 있다",
        "모두가 불이 붙는 메탄가스 방귀를 만드는 것은 아니다",
        "방귀는 가스 형태의 똥이 아니다",
        "냄새를 가진 방귀는 휘발성 가스이다.",
        "가장 독한 방귀들은 식품 속 아미노산(단백질 구성요소)을 분해한 결과로 만들어 진다.",
        "가장 독한 방귀를 만드는 재료인 아미노산은 특히 콩, 치즈, 육류에 많다.",
        "황화수소함유 방귀는 썩은 달걀냄새가 난다",
        "메탄사이올 함유 방귀는 썩은 양배추 냄새가 난다",
        "트리메틸아민 함유 방귀는 생선냄새가 난다",
        "메틸 사이오부티레이트 함유 방귀는 치즈냄새가 난다",
        "스카톨 함유 방귀는 고양이 똥 냄새가 난다",
        "안돌 함유 방귀는 꽃냄새같은 개똥 냄새가 난다",
        "디메틸 설파이드 함유 방귀는 양배추 냄새가 난다",
        "티올 함유 방귀는 계란 냄새가 난다",
        "방귀는 이루는 물질 중 하나인 황화수소는 고농축 상태에서 독성이 강하고, 부식을 일으키며 폭발할 수 있다",
        "방귀를 이루는 물질 중 하나인 스카톨은 소화할 때 분해되는 아미노산 트립토판으로부터 만들어진다",
        "방귀를 이루는 물질 중 하나인 인돌은 소화할 때 분해되는 아미노산 트립토판으로부터 만들어진다",
        "방귀냄새는 물에 녹는다",
        "자외선은 유기분자와의 상호작용을 통해 방귀를 산화시킨다",
        "액화 질소를 이용해 -196도로 차갑게 만들면 방귀보관이 가능하다",
        "액화 수소를 이용해 -253도로 온도를 낮추면 방귀보관이 가능하다",
        "청어는 공기를 삼킨 후에 의사소통 목적으로 방귀를 뀐다",
        "2015년 2000마리의 염소를 싣고 가던 비행기는 염소들이 방귀를 너무 많이 뀌는 바람에 어쩔수 없이 착륙해야했다	",
        "소는 방귀보다 트림 양이 더 많다.",
        "작은 부레관해파리는 항문이 없어 소화효소로 음식을 녹여먹으며 방귀를 뀌지 않는다",
        "새는 방귀를 만들어 낼 장내세균이 없고, 소화과정이 매우 빠르며 방귀를 뀌지 않는다",
        "흰개미는 전체 메탄가스 방출량의 5~19%를 만들어낸다",
        "돼지감자는 이눌린이라는 탄수화물함량이 높아 방귀를 많이 만들어 낸다.",
        "콩의 섬유질과 올리고당은 소장에 분해요소가 없어 대장에서 소화시키며 가스를 만들어 낸다",
        "양파,마늘은 복합탄수화물인 프룩탄을 함유하고 있으며, 대장에서 분해된다",
        "배추류에는 글루코시놀레이트(황과 질소를 함유한 아미노산과 포도당에서 생선되는 유기화합물)이 많은데, 이것들이 분해되면 냄새가 많이 나는 황화합물이 된다",
        "통곡류는 방귀가스의 양을 늘린다",
        "고단백 식품들은 보통 방귀의 양을 줄이고, 냄새를 심하게 만든다",
        "감자와 시리얼을 먹으면 황화수소가 75%가 적게 만들어 진다",
        "감자와 시리얼에는 대장에서 분해되어 방귀를 만드는 프룩탄이 들어있다",
        "우유에 있는 유당은 특히 유당분해효소 결핍증이 있는 사람에게 방귀를 증가시킨다.",
        "유당분해효소 결핍증이 있는 사람은 소장에 유당분해효소가 없어 대장세균이 유당을 분해하여 수소가스를 만든다",
        "단백질은 황을 만들어내는데, 단백질 보충제를 먹으면 장내 세균의 황화수소 배출이 늘어난다",
        "설탕 대용품은 소르비톨은 분자량이 커서 대장에서 소화되고, 가스 생성을 유발한다.",
        "쌀은 방귀를 유발하지 않는다.",
        "글루텐프리 빵은 방귀를 유발하지 않는다.",
        "육류와 생선은 냄새는 나지만 방귀의 양을 줄인다	",
        "토마토와 포도, 수박은 방귀를 유발하지 않는 과일이다.",
        "상추와 호박은 방귀를 유발하지 않는다.",
        "아보카도는 방귀를 유발하지 않는다.",
        "방귀 속에 들어있는 수소는 폭발성이 매우 강하다	",
        "방귀 속의 수소와 산소 농도는 낮은편이다.",
        "방귀 속의 황화수소는 극소량일때 세포의 미토콘드리아를 보호해준다",
        "보통 사람의 장 속에는 200g정도의 세균이 들어있다.",
        "장 내 세균은 700여종의 세균, 100조 마리 정도의 균류, 원생동물로 이루어져 있다",
        "장내 세규은 정신건강에서 염증유발, 자가면역에 이르기까지 많은 의료영역에서 중요한 역할을 한다",
        "방귀가 장 속에 너무 오래 머무르면 가스가 혈류로 재흡수되어 호흡으로 배출 될 수도 있다",
        "치명적인 방귀가 뜨거운 이유는 장에서 세균이 식이섬유를 분해하는 이화작용에서 화학적 에너지가 열에너지로 전환되며 열을 발생시키기 때문이다",
        "방귀를 적외선으로 포착한 영상은 거짓이다",
        "방귀를 적외선 카메라로 포착하는건 불가능한 일이다",
        "방귀가 빠져나갈때 조임근 조절을 통해 방귀의 음을 바꿀 수 있다",
        "화장실 쓰레기가 하수처리장을 통과하는 과정은 인간의 소화과정과 비슷하다",
        "콩 섭취를 줄이면 방귀를 줄일 수 있다",
        "섬유질이 많은 채소를 줄이면 방귀를 줄일 수 있다",
        "무언가를 씹거나 마시는 속도를 늦추면 방귀를 줄일 수 있다",
        "사탕을 덜 빨면 방귀를 줄일 수 있다",
        "담배를 끊으면 방귀를 줄일 수 있다",
        "껌을 씹지 않으면 방귀를 줄일 수 있다",
        "고도가 높은 곳에 올라가지 않으면 방귀를 줄일 수 있다",
        "고도가 높아지고 기압이 떨어지면 이산화탄소가 체내에서 확산하게 되고, 이것이 장을 팽창시키면서 가스의 양을 늘린다",
        "한번에 먹는 양을 줄이면 방귀를 줄일 수 있다",
        "이산화탄소가 많이 있는 방귀는 평소보다 훨씬 냄새가 덜 날 가능성이 크다	",
        "탄산음료를 줄이면 방귀를 줄일 수 있다",
        "페퍼민트차는 위 근육을 진정시키고, 복부통증을 줄여준다	",
        "남자의 경우 맥주를 피하면 방귀의 냄새를 줄일 수 있다",
        "방귀의 냄새를 줄이기 위해서는 배추류를 너무 많이 익혀 황화수소 양을 늘리지 않도록 해야한다",
        "방귀의 냄새를 줄이기 위해서는 마늘과 양파를 피해야한다	",
        "방귀의 냄새를 줄이기 위해서는 기름진 음식을 피해야한다	",
        "방귀를 걸러주는 숯으로 패드를 댄 바지가 있다",
        "미스터 메탄은 1분동안 방귀를 뀌며, 가스로 촛불을 끈다",
        "스테판 게이츠는 음식과 과학을 주제로 글을 쓰는 작가이며 열렬한 방귀애호가이다",
        "스테판 게이츠는 방구학 개론의 저자이다",
        "스테판 게이츠는 가스트로너트Gastronuts라는 BBC프로그램에서 진행자를 맡았다",
      ],
      endMessage:"내가 바닷가에서 {count}개의 페트병을 줍는 {time} 동안, 기업에서는 {total}개의 새로운 페트병을 생산했다.",
      sec:"초",
      min:"분",
      noPet:"PET 병을 골라내세요"
    }
  },
  en: {
    message: {
      btnGameStart: 'Start',
      cutsceneTitle1: 'What can I do for the Earth',
      cutsceneTitle2: 'that is being destroyed?',
      cutsceneTitle3: 'I,',
      cutsceneTitle4: 'decided',
      cutsceneTitle5: 'not to fart',
      cutsceneTitle6: 'from today.',

      cutsceneTitle1o: 'I have held farts',
      cutsceneTitle2o: 'all my life',
      cutsceneTitle3o: 'to save the earth.',
      cutsceneTitle4o: 'And now...',
      cutsceneTitle5o: 'I,',
      cutsceneTitle6o: 'decide to',
      cutsceneTitle7o: 'pick up',
      cutsceneTitle8o: 'the PET bottles.',
      btnSignStart: 'Sign and start',
      warnName: 'Enter your name!',
      btnGameStart2: 'Play the game',
      btnGameRank: 'Leaderboard',
      rank1: '1st',
      rank2: '2nd',
      rank3: '3rd',
      rankTotal: 'Total amount of methane gas collected?',
      rankCount: 'How many people have held farts?',
      btnClose: 'Close',
      warnRotation: 'Plese use vertical mode!',
      infoTouch: 'Use three fingers to start!',
      warnMobile: 'Play the game on mobile phones!',
      gameEndTitle: 'Failed to hold fart',
      gameEndDesc1: 'But,',
      gameEndDesc2: 'your fart will be remembered',
      gameEndTitleO: 'PET separation Failed',
      gameEndDesc1O: 'Your attempt will fail again.',
      btnSave: 'Save',
      btnReplay: 'Play again',
      me: 'ME',
      player: 'players',
      placeholder: 'your name',
      info1: '3 fingers on the screen to start',
      info2: 'Avoid nature',
      info3: 'Keep your fingers on your screen',
      info4: 'Face element changed',
      info5: 'CC booster activated',
      info6: 'Became invincible',
      warn: 'Please use portrait mode',
      btnShare: 'Share',
      infoSave:'Long press the image to save',
      btnLoading:'Loading...',
      bubble: [
        "Farts with a lot of carbon dioxide are more likely to smell much less than usual",
        "Farting can be reduced if you don't go up to high altitude",
        "Termites make 5 to 19% of total methane gas emissions",
        "Adults usually make 0.5 to 1.5 liters of fart per day",
        "Fart is a mixture of gas generated by fermentation of intestinal contents with air that enters through the mouth along with food",
        "Tomatoes, grapes, and watermelon are fruits that do not cause fart",
        "The most toxic farts are made as a result of breaking down amino acids (protein components) in food",
        "If the fart stays in the intestine for too long, the gas may be reabsorbed into the bloodstream and released through breathing",
        "Intestinal bacteria play an important role in many medical fields, from mental health to inflammation and autoimmunity",
        "Cows burp more than farts",
      ],
      endMessage:"In {time} I picked up {count} PET bottles from the beach, the company produced {total} new PET bottles.",
      sec:"sec",
      min:"min",
      noPet:"Please pick a PET bottle!"

    }
  },
}
const getNavigatorLanguage = () => {
  var rVal = getUserLocale();
  console.log(rVal)
  if (rVal.includes("kr") || rVal.includes("ko")) {
    return 'kr';
  }
  return 'en';
}

const i18n = new VueI18n({
  locale: getNavigatorLanguage(), // set locale
  messages, // set locale messages
})
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')


class SoundManager {
  public Play() {
    console.log("PLAY TEST")
  }
}